import React from "react";

const VIDEO_PATH = require("./images/handyman_video.mp4");

function Video_handyman(props) {
  return (
    <div className="video text-2xl px-2 h-[400px] sm:h-[550px] sm:text-3xl mt-24 sm:mt-32 font-bold pb-10 sm:pb-30 pt-10 bg-gray-100 flex flex-col items-center text-white">
      <video
        width="650"
        height="300"
        controls
        controlsList="nodownload"
        oncontextmenu="return false"
        autoPlay
        muted
        loop
        className="rounded-lg shadow-2xl"
      >
        <source src={VIDEO_PATH} type="video/mp4" />
      </video>
      <p className="text-black mt-5 text-sm sm:text-2xl">
        We're excited to have you join our team!
      </p>

      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSejrZ4k_Nf6jgHT2a3ycJ5yquG8kjOf81k37AKwebdg6cx6Cg/viewform?usp=sf_link"
        target="_blank"
        rel="noreferrer"
      >
        <button className="mt-4 mb-12 px-20 py-4 text-white font-bold text-sm sm:text-lg duration-150 bg-green-600 rounded-full hover:bg-green-500 active:bg-green-700">
          Registration form
        </button>
      </a>
    </div>
  );
}

export default Video_handyman;
